var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlphabet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#617995;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.24,11.41H5.08l-0.38-1.12H2.51l-0.38,1.12H0.98L3,6.08h1.22L6.24,11.41z M3.61,6.98L2.81,9.4h1.6L3.61,6.98 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.77,9.91c0,0.24-0.05,0.45-0.16,0.63c-0.11,0.18-0.26,0.34-0.45,0.47c-0.19,0.13-0.42,0.23-0.7,0.3 s-0.57,0.1-0.9,0.1H6.95V6.08h1.82c0.27,0,0.52,0.03,0.74,0.09c0.22,0.06,0.41,0.15,0.56,0.26c0.15,0.11,0.27,0.24,0.36,0.4 c0.08,0.15,0.13,0.33,0.13,0.51c0,0.34-0.1,0.61-0.29,0.82s-0.46,0.37-0.8,0.47c0.38,0.06,0.7,0.2,0.93,0.41 C10.65,9.25,10.77,9.55,10.77,9.91z M8.53,8.26c0.28,0,0.5-0.06,0.68-0.18c0.17-0.12,0.26-0.3,0.26-0.52 c0-0.21-0.07-0.37-0.22-0.47c-0.15-0.1-0.35-0.15-0.61-0.15H8.05v1.33H8.53z M9.67,9.83c0-0.24-0.1-0.42-0.3-0.54 C9.16,9.17,8.9,9.11,8.58,9.11H8.05v1.46h0.59c0.35,0,0.61-0.07,0.78-0.2C9.58,10.23,9.67,10.05,9.67,9.83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.18,5.99c0.13,0,0.27,0.01,0.41,0.02s0.27,0.03,0.4,0.06s0.26,0.05,0.38,0.09 c0.12,0.03,0.23,0.08,0.32,0.12l-0.16,0.82c-0.17-0.06-0.36-0.12-0.57-0.16s-0.41-0.06-0.62-0.06c-0.61,0-1.07,0.16-1.4,0.47 c-0.32,0.32-0.48,0.78-0.48,1.4c0,0.62,0.16,1.08,0.48,1.4c0.32,0.32,0.79,0.47,1.4,0.47c0.2,0,0.41-0.02,0.62-0.06 s0.4-0.09,0.57-0.16l0.16,0.82c-0.1,0.05-0.2,0.09-0.32,0.12c-0.12,0.04-0.25,0.06-0.38,0.09s-0.27,0.04-0.4,0.05 c-0.14,0.01-0.27,0.02-0.41,0.02c-0.46,0-0.86-0.07-1.22-0.21c-0.35-0.14-0.65-0.33-0.89-0.58c-0.24-0.25-0.42-0.54-0.54-0.87 c-0.12-0.34-0.18-0.7-0.18-1.1s0.06-0.77,0.18-1.1c0.12-0.34,0.3-0.63,0.54-0.87c0.24-0.25,0.54-0.44,0.89-0.58 C13.32,6.06,13.73,5.99,14.18,5.99z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlphabet);
export default __webpack_public_path__ + "static/media/alphabet.ea96bbc68cf5c0fb438a099ee9c30fcf.svg";
export { ForwardRef as ReactComponent };